<div class="flex flex-col flex-1 bg-white">
  <div class="grid grid-cols-6">
    <div class="flex col-span-6">
      <dx-form
        [formData]="formData"
        [items]="items"
        (onFieldDataChanged)="onFieldDataChanged($event)"
        class="flex-1"
      >
      </dx-form>
    </div>
  </div>
</div>
